import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import authAxios from "../../../config/authAxios"


const initialState = { status: null, loading: false, data: [], error: "", message: "",totalPages:0 }



export const getSinglePartnerAction = createAsyncThunk(
    'single-partner',
    async (data, { rejectWithValue }) => {
        try {
            const res = await authAxios.get(`/admins/api/get/single/partner?partnerId=${data?.partnerId}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getSinglePartnerSlice = createSlice({
    name: 'single-partner',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getSinglePartnerAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getSinglePartnerAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.totalPages = action?.payload?.totalPages
            })
            builder.addCase(getSinglePartnerAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getSinglePartnerReducer = getSinglePartnerSlice.reducer